import {
    ADMIN_CONFIG,
    AVAILABLE_HOUR,
    CHANGE_APPOINTMENT_TYPE_NAME,
    CHANGE_BRANCH_NAME,
    CHANGE_CALENDAR_STEP,
    CHANGE_PARAMS_APPOINTMENT_DATE,
    CHANGE_PARAMS_APPOINTMENT_TYPE_ID,
    CHANGE_PARAMS_BRANCH_ID,
    CHANGE_PARAMS_FORM_VAL,
    GET_APPOINTMENT_PAGE_STEPS,
    GET_APPOINTMENT_TYPES,
    GET_BRANCHES,
    GET_HOME_DATA,
    PARAMS_VERIFY_TOKEN_RESPONSE, RESET_VALUES,
    SET_PARAMS_FROM_APPOINTMENT_EDIT,
    USER_COMPLETED_STEPS,
    VERIFY_TOKEN_RESPONSE
} from '../constants/actionTypes'

const initialState = {letClick: false,unavailableHour:[],pageSteps:[]};

const homeReducer = (state = initialState, action) => {

    switch (action.type) {


        case GET_HOME_DATA:
            return {
                ...state,
                success: {...state.success, ...action.payload},
                ...action.payload
            };
        case GET_BRANCHES:
            return {
                ...state,
                branches: action.payload,
            };
        case CHANGE_BRANCH_NAME:
            return {
                ...state,
                activeBranchName: action.payload,
            };
        case CHANGE_APPOINTMENT_TYPE_NAME:
            return {
                ...state,
                activeAppointmentTypeName: action.payload,
            };
        case GET_APPOINTMENT_TYPES:
            return {
                ...state,
                appointmentTypes: action.payload,
            };
        case AVAILABLE_HOUR:
            return {
                ...state,
                unavailableHour: action.payload,
            };
        case VERIFY_TOKEN_RESPONSE:
            return {
                ...state,
                tokenResponse: action.payload,
            };
        case CHANGE_PARAMS_BRANCH_ID:
            return {
                ...state,
                paramsObj: {
                    ...state.paramsObj,
                    branch_id:action.payload
                }
            };
        case CHANGE_PARAMS_APPOINTMENT_TYPE_ID:
            return {
                ...state,
                paramsObj: {
                    ...state.paramsObj,
                    appointment_type_id:action.payload
                }
            };
        case PARAMS_VERIFY_TOKEN_RESPONSE:
            return {
                ...state,
                paramsObj: {
                    ...state.paramsObj,
                    sms_verification_code:action.payload
                }
            };
        case CHANGE_PARAMS_APPOINTMENT_DATE:
            return {
                ...state,
                paramsObj: {
                    ...state.paramsObj,
                    selected_date:action.payload
                }
            };
        case CHANGE_PARAMS_FORM_VAL:
            return {
                ...state,
                paramsObj: {
                    ...state.paramsObj,
                    ...action.payload
                }
            };
        case SET_PARAMS_FROM_APPOINTMENT_EDIT:
            return {
                ...state,
                paramsObj: action.payload

            };
        case GET_APPOINTMENT_PAGE_STEPS:
            return {
                ...state,
                pageSteps:[...action.payload]
            }
        case USER_COMPLETED_STEPS:
            return {
                ...state,
                completedSteps : {...state.completedSteps,...action.payload},

            }

        case CHANGE_CALENDAR_STEP:
            return {
                ...state,
                calendarStep:action.payload
            }
        case RESET_VALUES:
            return {
                ...state,
                activeAppointmentTypeName:null,
                activeBranchName:null,
                paramsObj:null,
            }

        case ADMIN_CONFIG:
            return {
                ...state,
                configs:action.payload
            }

        default:
            return state;
    }
};

export default homeReducer;